// signInstructionBuilder.js

const INSTRUCTION_SNIPPETS = {
    signType: {
        channel:
            'Channel Letters. Individual 3D fabricated letters with visible 3.5" deep returns/sides. Each letter is a separate fabricated element. Not a cabinet, light box, or flat panel sign.',

        neon:
            "LED Flex Neon. Continuous LED neon tubing following the artwork exactly. Mounted on a clear acrylic backing. Not channel letters.",

        alumCut:
            'Flat-Cut Aluminum Letters. Solid metal letters, 1/4"–1/2" thick. Premium brushed or painted metal finish. No lighting. Not channel letters.',

        acrylic3D:
            'Solid Acrylic Letters. Individual acrylic letters, 1/2"–1" thick. Smooth polished or painted finish. Not channel letters.',

        pvc:
            'PVC Letters. Individual routed PVC letters, 1/2"–1" thick. Painted finish with solid construction. Not channel letters.',

        lightbox:
            "Cabinet Sign. One illuminated cabinet with a flat translucent face. Uniform face illumination. Not individual letters.",

        push:
            "Push-Through Cabinet. Solid cabinet face with acrylic letters projecting through. Only acrylic elements illuminate.",

        blade:
            "Blade Sign. Double-sided projecting sign mounted perpendicular to the wall or façade. Visible from both directions. Preserve the original shape (round, square or rectangular), angle, proportions, and artwork exactly.",

        pylon:
            "Pylon Sign. Freestanding ground-mounted sign with one thick aluminum pole, frame, or structural base. Keep the sign face/background color exactly as shown in the input preview (artwork). Never wall-mounted. Keep freestanding structure and proportions.",

        film:
            "Vinyl Graphics. Flat printed or die-cut vinyl applied to surface. No depth, no glow, no fabricated letters.",

        banner:
            "Printed Banner. Flexible printed banner with flat graphics. Temporary signage look. No rigid structure.",

        printMat:
            "Printed ACM Panel. Rigid flat aluminum composite panel with printed graphics. No individual letters.",

        acrylicFace:
            "Printed Acrylic Panel. Flat acrylic face with printed graphics. Usually cabinet, pylon, or light box face. Not individual letters.",

        other:
            "Custom Sign. Follow supplied artwork and project instructions exactly."
    },

    addition: {
        "Backer Panel":
            "Backer Panel. Flat rectangular backer panel, 2 inches thick, mounted directly behind the sign. The panel must be only slightly larger than the artwork, with consistent margins around the logo. Not a cabinet, light box, or oversized background.",

        "Rails":
            "Mounting Bars. Install the sign on two horizontal 2 inches by 2 inches square aluminum tubes behind the letters. Match the square tube length to the overall width of the 3D sign."
    },

    nonIlluminated:
        "Lighting: Non-Illuminated. No glow, no halo, no internal lighting.",

    illuminated:
        "Lighting: Face-Lit. Front faces may illuminate evenly.",

    backLit:
        "Lighting: Reverse illuminated / halo-lit only. The front faces must remain opaque and non-glowing. Light is visible only as a glow on the wall behind each element."
};

function buildSmartInstructions(sign) {
    const parts = [];

    const baseType =
        INSTRUCTION_SNIPPETS.signType[sign.signType] ||
        INSTRUCTION_SNIPPETS.signType.other;

    const backLitSignTypes = [
        "channel",
        "alumCut",
        "acrylic3D",
        "pvc"
    ];

    if (
        sign.illuminated === "backLit" &&
        backLitSignTypes.includes(sign.signType)
    ) {
        parts.push(
            `Reverse illuminated / halo-lit 3D components. ${baseType}`
        );
    } else {
        parts.push(baseType);
    }

    if (sign.illuminated === "backLit") {
        parts.push(INSTRUCTION_SNIPPETS.backLit);
    } else if (sign.illuminated === true) {
        parts.push(INSTRUCTION_SNIPPETS.illuminated);
    } else {
        parts.push(INSTRUCTION_SNIPPETS.nonIlluminated);
    }

    const supportsAdditionalSetup = [
        "channel",
        "neon",
        "alumCut",
        "acrylic3D",
        "pvc"
    ].includes(sign.signType);

    if (
        supportsAdditionalSetup &&
        sign.addition &&
        INSTRUCTION_SNIPPETS.addition[sign.addition]
    ) {

        let additionInstruction = INSTRUCTION_SNIPPETS.addition[sign.addition];

        if (sign.additionColor) {

            const color =
                sign.additionColor === "#FFFFFF"
                    ? "white"
                    : sign.additionColor === "#000000"
                        ? "black"
                        : sign.additionColor;

            additionInstruction += ` The ${sign.addition.toLowerCase()} must be colored ${color.toUpperCase()}.`;
        }

        parts.push(additionInstruction);
    } else if (supportsAdditionalSetup) {
        parts.push(
            "Mount directly to the existing surface. No backer panel, rails, raceway, cabinet, or additional structure."
        );
    }

    // parts.push(
    //     "Artwork rule: preserve the supplied logo exactly. Do not change spelling, font, proportions, colors, background color, layout, or icon shapes. If the logo has a white background, keep it white. Never invent brand colors."
    // );

    return parts.filter(Boolean).join("\n\n");
}

export {
    INSTRUCTION_SNIPPETS,
    buildSmartInstructions
};